export default __webpack_public_path__ + "static/media/labyrinthen-tenancy-04.49f2de19.jpg";